import { Css } from "@homebound/beam";
import { useCallback, useRef } from "react";

interface ResizeDividerProps {
  onResize: (delta: number) => void;
}

/** A vertical draggable divider that sits between two panels. */
export function ResizeDivider({ onResize }: ResizeDividerProps) {
  const dragging = useRef(false);
  const lastX = useRef(0);

  const handleMouseDown = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      dragging.current = true;
      lastX.current = e.clientX;

      const handleMouseMove = (ev: MouseEvent) => {
        if (!dragging.current) return;
        const delta = ev.clientX - lastX.current;
        lastX.current = ev.clientX;
        onResize(delta);
      };

      const handleMouseUp = () => {
        dragging.current = false;
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
        document.body.style.cursor = "";
        document.body.style.userSelect = "";
      };

      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp);
      document.body.style.cursor = "col-resize";
      document.body.style.userSelect = "none";
    },
    [onResize],
  );

  return (
    <div
      css={
        Css.wPx(6)
          .add("flexShrink", "0")
          .add("cursor", "col-resize")
          .df.aic.jcc.add("background", "transparent")
          .add("transition", "background 0.15s").$
      }
      onMouseDown={handleMouseDown}
      onMouseEnter={(e) => (e.currentTarget.style.background = "#d1d5db")}
      onMouseLeave={(e) => {
        if (!dragging.current) e.currentTarget.style.background = "transparent";
      }}
    >
      <div css={Css.wPx(2).hPx(32).br4.bgGray300.$} />
    </div>
  );
}
